import { useAppSelector } from '@online-webinar/store';
import { Link } from '@online-webinar/ui-frontend';
import { Popup, WebinarDate } from '../../atoms';

export const WebinarExpiredPopup = () => {
    const endOn = useAppSelector((state) => state.liveWebinar.endOn);
    if (!endOn) {
        return <></>; // If endOn is not defined, do not render the popup
    }

    return (
        <Popup isCloseFunctionality={false} hasWarning={true} onClose={() => {}} onConfirm={() => {}} open={true} title="This webinar has expired">
            <div>
                <p className="notallowed-broadcast">
                    We noticed that you want to start your event past the scheduled end time. This event has expired automatically on{' '}
                    <WebinarDate date={endOn} /> and broadcasting is not possible. Please schedule a new event and update your subscribers.
                </p>
                <Link to="/" variant="primary-outline" classNames="mt-4">
                    Go back
                </Link>
            </div>
        </Popup>
    );
};
